export class FbSellerInfoConfiguration{


    constructor(public seller : string, public avatar? : string){}

    public static create = (seller : string) => new FbSellerInfoConfiguration(seller)

    setAvatar(value :string) : FbSellerInfoConfiguration{

        this.avatar = value;
        return this;

    }


}
